export default __webpack_public_path__ + "static/media/car.18049226.png";